import { render, staticRenderFns } from "./msgtypeMixed.vue?vue&type=template&id=5812529e&scoped=true&"
import script from "./msgtypeMixed.vue?vue&type=script&lang=js&"
export * from "./msgtypeMixed.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeMixed.vue?vue&type=style&index=0&id=5812529e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812529e",
  null
  
)

export default component.exports